const shouldFlipBG = (inputElParent: any, theme: 'day' | 'night') => {
  let bgColor = 'rgba(0, 0, 0, 0)';
  if (inputElParent && inputElParent.current) {
    let thresholdCount = 0;
    let bgParentElem = inputElParent.current;
    while (
      thresholdCount < 10 &&
      bgParentElem.parentNode &&
      bgParentElem.parentNode instanceof window.HTMLElement &&
      (bgColor === 'rgba(0, 0, 0, 0)' || bgColor === 'transparent')
    ) {
      thresholdCount += 1;
      bgColor = window.getComputedStyle(bgParentElem.parentNode)
        .backgroundColor;
      bgParentElem = bgParentElem.parentNode;
    }
    if (bgColor !== 'rgba(0, 0, 0, 0)') {
      if (
        (theme === 'night' && bgColor === 'rgb(41, 41, 56)') ||
        (theme === 'day' && bgColor === 'rgb(245, 245, 246)')
      ) {
        return true;
      }
    }
  }
  return false;
};

export default shouldFlipBG;
